import { useId } from 'react';
import type { ReactElement } from 'react';

import { Marker } from '@xing-com/marker';
import { Hero } from '@xing-com/typography';

import {
  CardActionGroup,
  CardBenefitsList,
  CardContainer,
  CardDiscoverButton,
  CardHeaderSection,
  CardPricing,
} from './sub-components';
import * as Styled from './unpromoted-card.styled';
import type { UnpromotedCardProps } from './unpromoted-card.types';

export type { UnpromotedCardProps } from './unpromoted-card.types';

export const UnpromotedCard = ({
  title,
  benefitsTitle,
  benefits,
  price,
  previousPrice,
  marker,
  action,
  activationUrl,
  cancellation,
  detailsUrl,
  discover,
  onDiscover,
  perks,
}: UnpromotedCardProps): ReactElement => {
  const titleId = useId();

  return (
    <CardContainer
      aria-labelledby={titleId}
      as="article"
      size="large"
      padding="regular"
    >
      <CardHeaderSection>
        <Styled.Headline>
          <Hero as="h2" id={titleId} size="small" noMargin>
            {title}
          </Hero>
          {marker ? (
            <Marker role="presentation" variant="highlight">
              {marker}
            </Marker>
          ) : null}
        </Styled.Headline>
        <CardPricing price={price} previousPrice={previousPrice} />
        <CardActionGroup
          action={action}
          activationUrl={activationUrl}
          cancellation={cancellation}
        />
      </CardHeaderSection>
      <Styled.BenefitsSection>
        <CardBenefitsList benefits={benefits} benefitsTitle={benefitsTitle} />
        <CardDiscoverButton
          action={action}
          activationUrl={activationUrl}
          cancellation={cancellation}
          detailsUrl={detailsUrl}
          discover={discover}
          onDiscover={onDiscover}
          perks={perks}
          previousPrice={previousPrice}
          price={price}
          title={title}
        />
      </Styled.BenefitsSection>
    </CardContainer>
  );
};
